const G = "#b8960c";

export default function Footer() {
  return (
    <footer className="border-t border-white/8 py-10 mt-4" style={{ background: "#0a0a0a" }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <p className="text-xs text-center tracking-[0.25em] uppercase mb-5 font-semibold" style={{ color: G }}>Stay Connected</p>
        <div className="flex justify-center gap-3 flex-wrap mb-6">
          {[["Facebook", "https://facebook.com"], ["LinkedIn", "https://linkedin.com"], ["Instagram", "https://instagram.com"], ["TikTok", "https://tiktok.com"]].map(([name, href]) => (
            <a key={name} href={href} target="_blank" rel="noreferrer"
              className="text-xs text-gray-500 px-4 sm:px-5 py-2 border border-white/10 hover:border-yellow-600/50 hover:text-yellow-500 transition-all tracking-widest uppercase font-medium rounded-sm">
              {name}
            </a>
          ))}
        </div>
        <div className="w-10 h-0.5 mx-auto mb-4" style={{ background: G }} />
        <div style={{ fontFamily: 'Playfair Display, serif' }} className="text-center font-black text-lg text-white mb-1">
          Wilson Omonzokpia<span style={{ color: G }}>.</span>
        </div>
        <p className="text-xs text-gray-700 text-center tracking-wide">2026 · Berlin, Germany · IT Specialist</p>
      </div>
    </footer>
  );
}